import { render } from "./fldSubtype.vue?vue&type=template&id=6c101ef4"
import script from "./fldSubtype.vue?vue&type=script&lang=js"
export * from "./fldSubtype.vue?vue&type=script&lang=js"

import "./fldSubtype.vue?vue&type=style&index=0&id=6c101ef4&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QColor from 'quasar/src/components/color/QColor.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QSeparator,QColor,QField});
